/**
 * Pseudo-Random Number Generator (Mulberry32) and Seed Utilities.
 * Provides 100% deterministic game shuffling for testing, bug reproduction, and multiplayer sync.
 */

export function hashStringToSeed(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return hash;
}

export function createPrng(seed: number | string): () => number {
  let s: number;
  if (typeof seed === 'number' && !Number.isNaN(seed)) {
    s = seed;
  } else if (typeof seed === 'string') {
    s = hashStringToSeed(seed);
  } else {
    s = hashStringToSeed(generateRandomSeed());
  }
  return function () {
    s |= 0;
    s = (s + 0x6d2b79f5) | 0;
    let t = Math.imul(s ^ (s >>> 15), 1 | s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function generateRandomSeed(): string {
  // Generate a clean 6-digit numeric string (e.g. "849201")
  return Math.floor(100000 + Math.random() * 900000).toString();
}

